package org.example.project.enginechat

import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import org.example.project.dashboard.ContentOffset
import org.example.project.dashboard.PopupEngineCard
import org.example.project.screens_shared.SHAREDTerminverwaltung
import org.example.project.service.KontaktKalenderPopupService

@Composable
fun KontaktKalenderOverlayLayer(node: String) {
    val popups = KontaktKalenderPopupService.getPopups(node)

    popups.forEachIndexed { index, popup ->
        PopupEngineCard(
            windowKey = popup.id,
            widthPx = 980,
            heightPx = 700,
            initialX = 240.0 + ((index % 4) * 36.0),
            initialY = 120.0 + ((index % 4) * 28.0),
            contentInsetLeft = ContentOffset.LEFT.value.toDouble(),
            contentInsetTop = ContentOffset.TOP.value.toDouble(),
            contentInsetRight = ContentOffset.RIGHT.value.toDouble(),
            contentInsetBottom = ContentOffset.BOTTOM.value.toDouble(),
            onClose = { KontaktKalenderPopupService.closePopup(node, popup.id) }
        ) {
            key(popup.id) {
                SHAREDTerminverwaltung(
                    art = popup.art,
                    node = popup.bereich,
                    sourceUserId = popup.userName,
                    sourceFirmenId = popup.firmenId.trim(),
                    bookingTemplate = KontaktKalenderPopupService.bookingTemplate(popup.id),
                    onBookingSaved = KontaktKalenderPopupService.bookingCallback(popup.id)
                )
            }
        }
    }
}
